/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 24.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';
import Platform from 'platform';

import Tooltip from 'rc-tooltip';
import classnames from 'classnames';

import Translate from '../Translate';

import _get from 'lodash/get';
import moment from 'moment';

import {EPG_EVENT_MIN_DURATION} from '../../utils';

class EpgGridEventItem extends Component {
  constructor(props) {
    super(props);

    this.descriptionCss = {left: 0};
    this.descOffsetXCalc = 0;

    let now = moment().unix();

    this.state = {
      momentStart: moment.unix(this.props.event.start),
      momentEnd: moment.unix(this.props.event.start + this.props.event.duration),
      col: this.props.col,
      positionAndSize: {
        left: this.props.event._offset + 'px',
        width: this.props.event._width + 'px',
        zIndex: this.props.col
      },
      isNow: !!this.props.isToday && (_get(this.props, 'event.start') <= now) && (_get(this.props, 'event.start') + _get(this.props, 'event.duration') > now),
      isPast: now > _get(this.props, 'event.start') + _get(this.props, 'event.duration'),
      isFuture: now < _get(this.props, 'event.start')
    };
  }

  componentWillReceiveProps(newProps) {

    let now = moment().unix();

    this.setState({
      isNow: !!newProps.isToday && (_get(newProps, 'event.start') <= now) && (_get(newProps, 'event.start') + _get(newProps, 'event.duration') > now),
      isPast: now > _get(newProps, 'event.start') + _get(newProps, 'event.duration'),
      isFuture: now < _get(newProps, 'event.start')
    });

  }

  shouldComponentUpdate(nextProps, nextState) {

    return this._needUpdateDescriptionPosition(nextProps.event._offset, nextProps.event._width)
      || (this.props.isToday && this.props.now !== nextProps.now);
  }

  componentDidUpdate() {

    if (ReactDOM.findDOMNode(this)) this.$eventDesc = ReactDOM.findDOMNode(this).querySelector('.pt.ph.event-desc');
  }

  _openProgramProfile = () => {
    if (!this.props.event.is_fake) this.props.onEventSelect(this.props.event);
  }

  _hasSubTitle() {

    return _get(this.props, 'event.title') !== _get(this.props, 'event.program.title');
  }

  _needUpdateDescriptionPosition(offsetX, widthPx) {

    return (_get(Config, 'epg.left_align_title', true) && _get(this.props, 'gridOffset.leftPosition', 0) > offsetX &&
    (_get(this.props, 'gridOffset.leftPosition', 0) - offsetX) < widthPx);
  }

  _screwIE() {

    return Platform.name === 'IE';
  }

  _renderIcons() {
    let icons = [];

    if (_get(this.props, 'event.is_catchup_available') && !_get(this.props, 'event.catchup_start_correction')) {
      icons.push(<i key='catchup' className="ic ic-catchup ic-10px pl-"></i>);
    } else if (_get(this.props, 'event.is_catchup_available') && _get(this.props, 'event.catchup_start_correction')) {
      icons.push(<i key='catchup2' className="ic ic-catchup2 ic-10px pl-"></i>);
    }

    if (_get(this.props, 'event.record')) {

      icons.push(<i key='record' className="ic ic-rdvr ic-16px pl- mr" style={{position: 'relative', top: '2px'}}></i>);
    }

    if (_get(this.props, 'event.notification')) {

      icons.push(<i key='notification' className="ic ic-notification ic-10px"></i>);
    }

    return icons;
  }

  render() {

    let eventClasses = classnames({
      'block-now': this.state.isNow,
      'no-data': _get(this.props, 'event.is_fake'),
      'block-cast col bg-black radius': true
    });

    if (this.props.event.duration <= EPG_EVENT_MIN_DURATION) {
      return (<div
        className="epg-event"
        style={this.state.positionAndSize}
        data-duration={this.props.event.duration}
        onClick={this._openProgramProfile}>
        <div className={eventClasses}>
          <a className="profile-show hover">
            <Tooltip
              placement="top"
              destroyTooltipOnHide={true}
              overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
                <div className="pt ph event-desc">
                  <div className="time">
                    <b>
                      {this.state.momentStart.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))}
                      <div className="icons pl-">{this._renderIcons()}</div>
                    </b>
                  </div>
                  <span className="program-title color-grey">
                     {!_get(this.props, 'event.is_fake') ? _get(this.props, 'event.program.title') : <Translate content="epg.no_data" />}
                  </span>
                  {this._hasSubTitle() && <span className="program-title color-grey">{_get(this.props, 'event.title')}</span>}
                </div>
              </div>}>
              <div className="block-note crow no-gutter">
                <i className="ic ic-info-circle"></i>
              </div>
            </Tooltip>
          </a>
        </div>
      </div>);
    }

    if (!this._screwIE() && _get(this.$eventDesc, 'offsetWidth', 0) < this.props.event._width && this._needUpdateDescriptionPosition(this.props.event._offset, this.props.event._width)) {

      this.descOffsetXCalc = _get(this.props, 'gridOffset.leftPosition', 0) - this.props.event._offset;

      if (this.descOffsetXCalc + _get(this.$eventDesc, 'offsetWidth', 0) > this.props.event._width) {
        this.descriptionCss = {left: this.props.event._width - _get(this.$eventDesc, 'offsetWidth', 0)};
      } else {
        this.descriptionCss = {left: this.descOffsetXCalc};
      }

    } else {
      this.descriptionCss = {left: 0};
    }

    return (
      <div id={'programme_' + this.props.event.id}
           className="epg-event"
           style={this.state.positionAndSize}
           data-duration={this.props.event.duration}
           onClick={this._openProgramProfile}>
        <div className={eventClasses}>
          <a className="profile-show hover">
            <div className="block-note"
                 style={this.descriptionCss}>
              <div className="pt ph event-desc">
                <div className="time">
                  <strong>
                    <span className={this.state.isPast ? 'color-grey' : ''}>{this.state.momentStart.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))}</span>
                    <div className="icons pl-">{this._renderIcons()}</div>
                  </strong>
                </div>
                <span className="program-title color-grey">
                  {!_get(this.props, 'event.is_fake') ? _get(this.props, 'event.program.title') : <Translate content="epg.no_data" />}
                </span>
                {this._hasSubTitle() && <span className="program-title color-grey">{_get(this.props, 'event.title')}</span>}
              </div>
            </div>
          </a>
        </div>
        {!this.state.isNow && <div className="block-right-grad block-event-grad radius hover"></div>}
      </div>
    );
  }
}

EpgGridEventItem.propTypes = {
  event: PropTypes.shape({
    start: PropTypes.number.isRequired,
    duration: PropTypes.number.isRequired
  }),
  gridOffset: PropTypes.shape({
    leftPosition: PropTypes.number.isRequired,
    topPosition: PropTypes.number.isRequired
  }),
  onEventSelect: PropTypes.func.isRequired,
  col: PropTypes.number,
  row: PropTypes.number
};

export default EpgGridEventItem;



// WEBPACK FOOTER //
// ./src/components/EPGGrid/epg-grid-event-item.js